export default {
    INCREMENT_LOADING_COUNTER: 'INCREMENT_LOADING_COUNTER',
    DECREMENT_LOADING_COUNTER: 'DECREMENT_LOADING_COUNTER'
};
